import {CHESTS} from '../constants/chests';

// Награда за ПЕРВЫЙ вход через установленное приложение — сундук Патриция.
// Тот же идентификатор знает сервер (APP_INSTALL_REWARD_CHEST_ID в
// server/index.js): клиент по нему рисует модалки, начисляет — сервер
export const APP_INSTALL_REWARD_CHEST_ID = CHESTS.RANDOM_EPIC;
